import { Box, 
  Link,
  Heading,
  Flex,
  Button,
  VStack,
  useMediaQuery,
  useDisclosure,
  useToast
 } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import Section from '../../../Component/Layout/Section';
import PageTitle from '../../../Component/Page/PageTitle';
import { useMutation, useQuery } from 'react-query';
import { deleteBoardPost, getBoardInfo, getBoardPost, getBoardPostAttached, getBoardPostOption, getWPPost, getWPPostAttached, getWPpostTypeInfo } from '../../../service';
import dayjs from 'dayjs';
import { PostBasicStyle, PostNewsletterStyle } from './style';
import { DownloadIcon } from '@chakra-ui/icons';
import { contentFilter, getYoutubeEmbedUrl } from '../../../util';
import { theme } from '../../../assets/style/theme';
import { responsiveValue } from '../../../assets/style/defaultTheme';
import Confirm from '../../../Component/Confirm';
import { boardLabels, defaultUserInfo, testUserInfo } from "../meta";

declare var __AUTH__: any;

const contentStyleExclude = [
  '24', // 뉴스레터
  '33' //shes view
]

type Props = {
  params:any;
};
function BoardView({ params }: Props) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();

  const toast = useToast();  

  const requestInfo = params.reqmode === 'wp' ? getWPpostTypeInfo : getBoardInfo;

  const requestPost = params.reqmode === 'wp' ? getWPPost : getBoardPost;

  const { isLoading:isLoadingPost, error:postError, data:post } = useQuery(['Post', params.reqmode, params.post_id], () => requestPost(params.post_id));

  const requestAttachment = params.reqmode === 'wp' ? getWPPostAttached : getBoardPostAttached;
  
  const { isLoading:isLoadingPostAttached, error:postAttachedError, data:postAttached } = useQuery(['PostAttached', params.reqmode, params.post_id], () => requestAttachment(params.post_id));
  
  const { isLoading:isLoadingPostOption, error:postOptionError, data:postOption } = useQuery(['PostOption', params.post_id], () => getBoardPostOption(params.post_id));

  const { isLoading:isLoadingBoardInfo, error:boardInfoError, data:boardInfo } = useQuery(['BoardInfo', params.reqmode, post?.board_id], () => requestInfo(post.board_id), {
    enabled: Boolean(post?.board_id)
  });

  const [userInfo, setUserInfo] = useState(defaultUserInfo);
  
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      setUserInfo(testUserInfo);
    } else {
      setUserInfo(__AUTH__ ? __AUTH__ : defaultUserInfo);
    }
  }, []);

  useEffect(() => {
    if (boardInfo && boardInfo?.permission_read !== 'all') {
      window.location.href = '/';
    }    
  }, [boardInfo]);

  const { mutate:mutateDeletePost } = useMutation(() => deleteBoardPost(params.post_id), {
    onSuccess: (data) => {
      toast({
        title: "게시글이 삭제되었습니다..",
        status: "success",
        duration: 3000,
        position: "top",
      });
      setTimeout(() => {
        window.location.href = `/board/?board_id=${params.board_id}`;
      }, 200);
    }
  });

  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  const headerStyle = {
    borderTopWidth: '3px',
    borderStyle: 'solid',
    borderTopColor: 'b.dgr',
    borderBottomWidth: '1px',
    borderBottomColor: 'b.dgr',
    pt: isMobile ? '4' : '10',
    pb: isMobile ? '4' : '10',
    pl: isMobile ? '2' : '4',
    pr: isMobile ? '2' : '4',
  }

  const postContentStyle = {
    borderBottomWidth: '1px',
    borderStyle: 'solid',
    borderBottomColor: 'b.dgr',
    pt: isMobile ? '2' : '14',
    pb: isMobile ? '2' : '14',
    pl: isMobile ? '0' : '4',
    pr: isMobile ? '0' : '4',
  }

  const attachedStyle = {
    borderBottomWidth: '1px',
    borderStyle: 'solid',
    borderBottomColor: 'b.lg',
  }

  const { flexBoxDirection } = responsiveValue;

  const isEnglish = window.__LANG__ === 'en';

  return (
    <>
      {
        !isLoadingPost && !isLoadingBoardInfo && !boardInfoError && (
        <>
        <PageTitle
          type="big"
          bgPath="board/news.jpg"
          title={boardInfo.parent_title}
          description={boardInfo.description}
        />

        <Section pt={isMobile ? 40 : 100} pb={isMobile ? 24 : 48} >        
          <Flex justifyContent="space-between">
            <Heading size={isMobile ? '3xl' : '5xl'} color="b.dgr">
              {boardInfo.board_name.replace(String.fromCharCode(92), '')}
            </Heading>
            {/* <Box>
              <Link href={`/board?board_id=${post.board_id}`}><Button size={isMobile ? 'md' : 'lg'} colorScheme="dgr">목록보기</Button></Link>
            </Box> */}
          </Flex>
        </Section>        
        </>
        )
      }

      {
        !isLoadingPost && !postError && (
        <>
          <Section pt={1} pb={48} >
            <Box {...headerStyle}>
              <Flex justify="space-between" direction={flexBoxDirection}>
                <Flex>
                  <Heading size={isMobile ? 'lg' : '2xl'} color="b.gr" mr="5">
                    {post.category1}
                  </Heading>
                  <Heading size={isMobile ? 'xl' : '2xl'} dangerouslySetInnerHTML={ {__html: contentFilter(post.title)} } pb={isMobile ? '2' : '0'}>
                  </Heading>
                </Flex>
                <Flex>
                  <Heading size={isMobile ? 'lg' : '2xl'} color="b.lg">
                    {dayjs(post.date).format('YYYY. MM. DD')}
                  </Heading>
                </Flex>
              </Flex>
            </Box>
            {
              !isLoadingPostAttached && !postAttachedError && postAttached.length !== 0 && (
                <VStack {...attachedStyle} spacing={0} align='stretch' >
                  {
                    postAttached.map((item:any, index:number) => (
                      <Box key={index} p={4}>
                        <Link href={ item.file_path.includes('http') ? item.file_path : `https://koreashe.org${item.file_path}`} target="_blank">
                          <DownloadIcon pr="1" />
                          {item.file_name}
                        </Link>
                      </Box>
                    ))
                  }
                </VStack>
              )
            }
            <Box {...postContentStyle}>
              {
                contentStyleExclude.includes(post.board_id) ? (
                  <PostNewsletterStyle dangerouslySetInnerHTML={ {__html: post.content_autop} } />
                ) : (
                  <PostBasicStyle isMobile={isMobile} dangerouslySetInnerHTML={ {__html: contentFilter(post.content_autop)} } />
                )
              }
              {
                !isLoadingPostOption && !postOptionError && postOption.length !== 0 && (
                  <>
                  {
                    postOption.filter((item:any) => item.option_key === 'youtube' ).map((item:any, index:number) => (
                      <Box key={index} textAlign="center" pt="10" >
                        <iframe title={`youtube-${item.content_uid || index}`} width="70%" height="450" style={{margin: '0 auto'}} src={getYoutubeEmbedUrl(item.option_value)} frameBorder="0" allow="autoplay; encrypted-media" ></iframe>
                      </Box>
                    ))
                  }
                  </>
                )
              }
            </Box>
            <Box pt="10" textAlign="right">
              <Link href={`${isEnglish ? '/en' : ''}/board?board_id=${post.board_id}${params.reqmode === 'wp' ? '&reqmode=wp' : ''}`}><Button size="md" colorScheme="dgr">{boardLabels('list', Number(params.board_id))}</Button></Link>              
              {
                userInfo.isLoggedIn && (userInfo.user.ID === post.member_uid || userInfo.role === 'administrator') && (
                  <>
                    <Link href={`${isEnglish ? '/en' : ''}/board?mode=edit&post_id=${params.post_id}&board_id=${post.board_id}${params.reqmode === 'wp' ? '&reqmode=wp' : ''}`}><Button size="md" colorScheme="dgr" ml={2}>{boardLabels('edit', Number(params.board_id))}</Button></Link>

                    <Button size="md" colorScheme="dgr" ml={2} onClick={onOpen}>{boardLabels('delete', Number(params.board_id))}</Button>
                  </>
                )
              }              
            </Box>
          </Section>
        </>
        )
      }
      <Confirm
        isOpen={isOpen}
        title="삭제하시겠습니까?"
        description="삭제된 글은 복구할 수 없습니다."
        onConfirm={mutateDeletePost}
        onClose={onClose}
        cancelRef={cancelRef}
      />
    </>
  );
}

BoardView.defaultProps = {
};

export default BoardView;
